import App from './App'

/* eslint-disable no-new */
// eslint-disable-next-line no-undef
new Vue({
  el: '#app',
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js